var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-template-page" }, [
    _c(
      "div",
      { staticClass: "steps-header" },
      [
        _c(
          "a-steps",
          { attrs: { current: _vm.currentStep, size: "small" } },
          [
            _c("a-step", {
              attrs: {
                title: "Set up template",
                status: _vm.currentStep > 0 ? "finish" : "process",
              },
            }),
            _vm._v(" "),
            _c("a-step", {
              attrs: {
                title: "Edit template",
                status:
                  _vm.currentStep > 1
                    ? "finish"
                    : _vm.currentStep === 1
                    ? "process"
                    : "wait",
              },
            }),
            _vm._v(" "),
            _c("a-step", {
              attrs: {
                title: "Submit for Review",
                status: _vm.currentStep === 2 ? "process" : "wait",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "main-content" }, [
      _c(
        "div",
        { staticClass: "content-wrapper" },
        [
          _c(
            "div",
            { staticClass: "form-area" },
            [
              _vm.currentStep === 0
                ? _c("TemplateSetup", {
                    attrs: {
                      form: _vm.form,
                      templateTypes: _vm.getTemplateTypes,
                      catalogueSubtypes: _vm.templateTypes.CATALOGUE_SUBTYPES,
                      authenticationSubtypes:
                        _vm.templateTypes.AUTHENTICATION_SUBTYPES,
                    },
                    on: {
                      "update-category": _vm.updateCategory,
                      "update-template-type": _vm.updateTemplateType,
                      "update-catalogue-subtype": _vm.updateCatalogueSubType,
                      "update-auth-subtype": _vm.updateAuthSubType,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === 1
                ? _c("div", { staticClass: "step-content" }, [
                    _c("div", { staticClass: "template-header-info" }, [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          class: _vm.getCategoryIcon,
                        },
                        [_vm._v(_vm._s(_vm.getCategoryIconName))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "info" }, [
                        _c("span", { staticClass: "template-name" }, [
                          _vm._v(
                            _vm._s(_vm.form.name || "your_template_name") +
                              " • " +
                              _vm._s(_vm.getLanguageLabel)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "template-meta" }, [
                          _vm._v(
                            _vm._s(_vm.form.category) +
                              " • " +
                              _vm._s(_vm.getTemplateTypeLabel)
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "section-card" }, [
                      _c("h4", [_vm._v("Template name and language")]),
                      _vm._v(" "),
                      _vm.editMode
                        ? _c(
                            "div",
                            {
                              staticClass: "edit-mode-notice",
                              staticStyle: {
                                "margin-bottom": "16px",
                                padding: "12px",
                                background: "#fff7e6",
                                border: "1px solid #ffd591",
                                "border-radius": "4px",
                                color: "#ad6800",
                                "font-size": "13px",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "material-icons",
                                  staticStyle: {
                                    "font-size": "16px",
                                    "vertical-align": "middle",
                                    "margin-right": "4px",
                                  },
                                },
                                [_vm._v("info")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "Template name and language cannot be changed when editing. You can only edit category (if not approved), components, and time-to-live."
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            staticStyle: { flex: "2" },
                          },
                          [
                            _c("label", [_vm._v("Name your template")]),
                            _vm._v(" "),
                            _c("a-input", {
                              attrs: {
                                disabled: _vm.editMode,
                                placeholder: "Enter a template name",
                                maxLength: 512,
                              },
                              on: { input: _vm.validateName },
                              model: {
                                value: _vm.form.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "name", $$v)
                                },
                                expression: "form.name",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "char-count" }, [
                              _vm._v(
                                _vm._s((_vm.form.name || "").length) + "/512"
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.errorInfo.name
                              ? _c("span", { staticClass: "error-text" }, [
                                  _vm._v(_vm._s(_vm.errorInfo.name)),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            staticStyle: { flex: "1" },
                          },
                          [
                            _c("label", [_vm._v("Select language")]),
                            _vm._v(" "),
                            _c(
                              "a-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.editMode,
                                  showSearch: "",
                                },
                                model: {
                                  value: _vm.form.language,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "language", $$v)
                                  },
                                  expression: "form.language",
                                },
                              },
                              _vm._l(_vm.languages, function (lang) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: lang.code,
                                    attrs: { value: lang.code },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(lang.label) +
                                        "\n                                    "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.form.templateType === "CAROUSEL"
                      ? _c(
                          "div",
                          { staticClass: "section-card" },
                          [
                            _c("h4", [_vm._v("Content")]),
                            _vm._v(" "),
                            _c("p", { staticClass: "description" }, [
                              _vm._v(
                                "\n                            Create two separate messages: First, a general text message (body). Second, carousel cards with images/videos. Each carousel card can have its own body text (optional) and buttons (required, at least 1). The general body message cannot have buttons - only carousel cards can have buttons.\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("BodyEditor", {
                              attrs: {
                                body: _vm.form.body,
                                variables: _vm.bodyVariables,
                                errorMessage: _vm.errorInfo.body,
                                rows: 4,
                                disableFormatting: true,
                              },
                              on: {
                                "update:body": function ($event) {
                                  _vm.form.body = $event
                                },
                                "add-variable": _vm.addVariable,
                                "update-variable-example":
                                  _vm.updateBodyVariableExample,
                              },
                            }),
                            _vm._v(" "),
                            _c("CarouselEditor", {
                              attrs: { cards: _vm.form.carouselCards },
                              on: {
                                "add-card": _vm.addCarouselCard,
                                "remove-card": _vm.removeCarouselCard,
                                "move-card-up": _vm.moveCarouselCardUp,
                                "move-card-down": _vm.moveCarouselCardDown,
                                "update-card-body": _vm.updateCarouselCardBody,
                                "add-card-variable":
                                  _vm.addCarouselCardVariable,
                                "update-card-variable-example":
                                  _vm.updateCarouselCardVariableExample,
                                "add-card-button": _vm.addCarouselCardButton,
                                "remove-card-button":
                                  _vm.removeCarouselCardButton,
                                "card-file-upload":
                                  _vm.handleCarouselCardFileUpload,
                                "remove-card-media":
                                  _vm.removeCarouselCardMedia,
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "section-card" },
                          [
                            _c("h4", [_vm._v("Content")]),
                            _vm._v(" "),
                            _c("p", { staticClass: "description" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.getContentDescription) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            !_vm.hasProductButton
                              ? _c("HeaderEditor", {
                                  attrs: {
                                    headerFormat: _vm.form.headerFormat,
                                    headerText: _vm.form.headerText,
                                    headerVariables: _vm.headerVariables,
                                    media: _vm.media,
                                    uploading: _vm.uploading,
                                    exampleMedia: _vm.form.exampleMedia,
                                    isProductHeader: _vm.hasProductButton,
                                    templateType: _vm.form.templateType,
                                  },
                                  on: {
                                    "update:headerFormat": function ($event) {
                                      _vm.form.headerFormat = $event
                                    },
                                    "update:headerText":
                                      _vm.handleHeaderTextUpdate,
                                    "update-header-variable-example":
                                      _vm.updateHeaderVariableExample,
                                    "file-upload": _vm.handleFileUpload,
                                    "remove-media": _vm.removeMedia,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasProductButton
                              ? _c(
                                  "div",
                                  { staticClass: "product-header-auto-info" },
                                  [
                                    _c("a-icon", {
                                      staticStyle: { color: "#1890ff" },
                                      attrs: { type: "info-circle" },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "Product header is automatically added from your catalogue. No manual configuration needed."
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.templateType === "LIMITED_TIME_OFFER"
                              ? _c("LimitedTimeOfferEditor", {
                                  attrs: { data: _vm.form.limitedTimeOffer },
                                  on: {
                                    update: function ($event) {
                                      _vm.form.limitedTimeOffer = $event
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("BodyEditor", {
                              attrs: {
                                body: _vm.form.body,
                                variables: _vm.bodyVariables,
                                errorMessage: _vm.errorInfo.body,
                              },
                              on: {
                                "update:body": function ($event) {
                                  _vm.form.body = $event
                                },
                                "insert-format": _vm.insertFormat,
                                "add-variable": _vm.addVariable,
                                "update-variable-example":
                                  _vm.updateBodyVariableExample,
                              },
                            }),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _vm.form.templateType !== "LIMITED_TIME_OFFER" &&
                    _vm.form.templateType !== "CAROUSEL"
                      ? _c("div", { staticClass: "section-card" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v("Footer • Optional")]),
                              _vm._v(" "),
                              _c("a-input", {
                                attrs: {
                                  placeholder: "Enter text",
                                  maxLength: 60,
                                },
                                model: {
                                  value: _vm.form.footer,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "footer", $$v)
                                  },
                                  expression: "form.footer",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "char-count" }, [
                                _vm._v(
                                  _vm._s((_vm.form.footer || "").length) + "/60"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.category === "AUTHENTICATION"
                      ? _c(
                          "div",
                          { staticClass: "section-card" },
                          [
                            _c("AuthenticationEditor", {
                              attrs: { data: _vm.form.authentication },
                              on: {
                                update: function ($event) {
                                  _vm.form.authentication = $event
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "section-card" },
                      [
                        _c("TTLEditor", {
                          attrs: {
                            value: _vm.form.messageSendTtlSeconds,
                            category: _vm.form.category,
                          },
                          on: {
                            update: function ($event) {
                              _vm.form.messageSendTtlSeconds = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.templateType !== "CAROUSEL"
                      ? _c(
                          "div",
                          { staticClass: "section-card" },
                          [
                            _c("ButtonEditor", {
                              attrs: {
                                buttons: _vm.form.buttons,
                                availableButtonTypes: _vm.availableButtonTypes,
                                templateType: _vm.form.templateType,
                                category: _vm.form.category,
                              },
                              on: {
                                "add-button": _vm.handleAddButton,
                                "remove-button": _vm.handleRemoveButton,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === 2
                ? _c(
                    "div",
                    { staticClass: "step-content" },
                    [
                      _vm.submitError
                        ? _c(
                            "a-alert",
                            {
                              staticClass: "submit-error-alert",
                              attrs: {
                                type: "error",
                                "show-icon": "",
                                closable: "",
                              },
                              on: {
                                close: function ($event) {
                                  _vm.submitError = null
                                },
                              },
                            },
                            [
                              _c("template", { slot: "message" }, [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.getErrorTitle)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("template", { slot: "description" }, [
                                _c("div", [
                                  _vm._v(_vm._s(_vm.getErrorMessage)),
                                ]),
                              ]),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-card review-card" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("h3", [_vm._v("Ready to submit")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                            Your template will be submitted to Meta for review. This usually takes a few minutes but\n                            can take up to 24 hours.\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "review-checklist" }, [
                          _c(
                            "li",
                            [
                              _c("a-icon", { attrs: { type: "check" } }),
                              _vm._v(
                                " Template name: " + _vm._s(_vm.form.name)
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c("a-icon", { attrs: { type: "check" } }),
                              _vm._v(" Category: " + _vm._s(_vm.form.category)),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c("a-icon", { attrs: { type: "check" } }),
                              _vm._v(
                                " Language: " + _vm._s(_vm.getLanguageLabel)
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c("a-icon", { attrs: { type: "check" } }),
                              _vm._v(" Body content added"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.form.buttons.length
                            ? _c(
                                "li",
                                [
                                  _c("a-icon", { attrs: { type: "check" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.form.buttons.length) +
                                      " button(s) added\n                            "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("TemplatePreview", {
            attrs: {
              form: _vm.form,
              currentStep: _vm.currentStep,
              media: _vm.media,
              headerVariables: _vm.headerVariables,
              bodyVariables: _vm.bodyVariables,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-footer" },
        [
          _vm.currentStep > 0
            ? _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.currentStep--
                    },
                  },
                },
                [_vm._v("Previous")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("a-button", { on: { click: _vm.viewTemplates } }, [
            _vm._v("Discard"),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { flex: "1" } }),
          _vm._v(" "),
          _vm.editMode && _vm.currentStep < 2 && !_vm.canProceed
            ? [
                _c(
                  "a-popover",
                  { attrs: { title: "Cannot Proceed", trigger: "hover" } },
                  [
                    _c("template", { slot: "content" }, [
                      _c("div", { staticStyle: { "max-width": "300px" } }, [
                        _vm._v(_vm._s(_vm.getChangeReason)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.currentStep < 2
                      ? _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: !_vm.canProceed,
                            },
                            on: { click: _vm.nextStep },
                          },
                          [
                            _vm._v(
                              "\n                        Next\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            : _vm.currentStep < 2
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary", disabled: !_vm.canProceed },
                  on: { click: _vm.nextStep },
                },
                [_vm._v("\n                Next\n            ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep === 2
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.submitTemplate },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.editMode ? "Update Template" : "Submit for Review"
                      ) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "review-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("check_circle")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }